export default "__VITE_ASSET__MtE7kS7D__"